
import Product from "./Product";
export default {
    components: {Product},
    props: ['products', 'editMode', 'editModeProcess', 'showMainSkipStatus', 'listName'],
    mounted() {
        this.sendImpressions();
    },
    watch: {
        products() {
            this.$nextTick(this.sendImpressions);
        },
    },
    methods: {
        sendImpressions() {
            if (this.$ecommerce && Array.isArray(this.products) && this.products.length > 0) {
                this.$ecommerce.impressions(this.products, this.listName || 'Catalog');
            }
        },
        changeMainSkip(id){
            this.$emit('change-main-skip', id);
        },
        changeMainRating(id, rating){
            this.$emit('change-main-rating', id, rating);
        },
    },
}
